import MESSAGES from 'core/data-model/constants/bi-messages'
import { getSumAssured } from 'quick-quote/product-common/coverage-plan/selectors'
import { getPolicyValues } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

import { createSelector } from 'reselect'

export const getDividendRatesByProductCode = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    default:
      return [
        { name: MESSAGES.TERM_LIFE_BENEFITS_LOW, rate: 0 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_MIDDLE, rate: 13 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_HIGH, rate: 40 },
      ]
  }
})

export const getInvestmentBenefitParams = createSelector(
  getPolicyValues,
  getDividendRatesByProductCode,
  getSumAssured,
  (policyValue, dividendRates, sumAssured) => ({ policyValue, dividendRates, sumAssured })
)

export const getInvestmentBenefit = (state) => state.benefitIllustration.investmentBenefit
